import time from "~/utils/basic/time";
import {db} from "~/utils/db";
import {ContentLocalTable} from "~/types/types-table";
import liuReq from "~/requests/liu-req";
import APIs from "~/requests/APIs";
import {nextTick} from "vue";
import liuUtil from "~/utils/liu-util/index";
import dbOp, {getNewCfg, getOldCfg} from "~/hooks/thread/db-op";
import {LocalToCloud} from "~/utils/cloud/LocalToCloud";
import {isAIExtractedItem} from "~/pages/level3/extracted-result-page/extracted-result-content/tools";

export async function handleContentsDelete(results:  ContentLocalTable[]) {
    if(results.length < 1) return
    const now = time.getTime()
    const list = results.map((v, i) => {
        v.oState = "DELETED"
        v.updatedStamp = now + i
        v.title = ""
        v.liuDesc = []
        v.images = []
        v.files = []
        v.tagIds = []
        v.tagSearched = []
        v.search_title = ""
        v.search_other = ""
        return v
    })

    // 把动态都改为 "DELETED"
    const res2 = await db.contents.bulkPut(list)
}
export async function handleContentRemove(id: string){
    const now = time.getTime()
    const oldCfg = await getOldCfg(id)
    const newCfg = getNewCfg("lastOStateStamp", now, oldCfg)

    const newData: Partial<ContentLocalTable> = {
        removedStamp: now,
        oState: "REMOVED",
        updatedStamp: now,
        config: newCfg,
    }
    const res = await db.contents.update(id, newData)

    LocalToCloud.addTask({
        uploadTask: "thread-delete",
        target_id: id,
        operateStamp: now,
    }, {
        speed: "instant"
    })
}
export const getNonCalendarContents = async (contents?: ContentLocalTable[])=>{
    let _contents = []
    if(!contents) {
        _contents = await db.contents.where({ oState: "OK" }).toArray()
    }else{
        _contents = contents
    }
    const firstIds = _contents.map(content=>content.first_id)
    if(!firstIds.length) return []
    const res = await liuReq.request<{
        firstId: string
        isSubscribed: boolean
        subscriptionInfo: {
            eventId: string
            status: 'inactive' | 'active'
            createTime: number
            lastSubscribeTime: number | null} | null
    }[]>(APIs.GET_CALENDAR_SUBSCRIBE_NOTIFICATION, { firstIds })
    console.log('提醒结果：', res.data)
    let target: ContentLocalTable[] = []
    if(res.data?.length){
        const unsubscribeItems = res.data.filter((item)=>{
            return (!item?.subscriptionInfo) || (!item?.subscriptionInfo?.eventId)
        })
        const unsubscribeFirstIds = unsubscribeItems.map((item)=>item.firstId)
        target = _contents.filter(content=>unsubscribeFirstIds.includes(content.first_id))
    }
    return target
}
export const getUnsubscribedContents = async (contents?: ContentLocalTable[])=>{
    let _contents = []
    if(!contents) {
        _contents = await db.contents.where({ oState: "OK" }).toArray()
    }else{
        _contents = contents
    }
    _contents = _contents.filter(content=>content.whenStamp)
    const firstIds = _contents.map(content=>content.first_id)
    if(!firstIds.length) return []
    const res = await liuReq.request<{
        firstId: string
        isSubscribed: boolean
        subscriptionInfo: {
            eventId: string
            status: 'inactive' | 'active'
            createTime: number
            lastSubscribeTime: number | null} | null
    }[]>(APIs.GET_CALENDAR_SUBSCRIBE_NOTIFICATION, { firstIds })
        console.log('提醒结果：', res.data)
    let target: ContentLocalTable[] = []
    if(res.data?.length){
        const unsubscribeItems = res.data.filter((item)=>{
            return !item.isSubscribed && (item?.subscriptionInfo?.eventId || isAIExtractedItem(item.firstId))
        })
        const unsubscribeFirstIds = unsubscribeItems.map((item)=>item.firstId)
        target = _contents.filter(content=>unsubscribeFirstIds.includes(content.first_id))
    }
    return target
}
export const getContentById = async (id: string)=>{
    const res0 = await db.contents.get(id)
    if(!res0 || res0.oState !== "OK") {
        console.log("contentId 不存在，或者已被删除........")
        console.log(res0)
        console.log(" ")
        return null
    }
    return res0
}